






























































































































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {Cell} from "@/models/Cell";
import {Grid} from "@/models/Grid";

@Component
export default class CellButton extends Vue {
	
	@Prop({type: Cell, required: true})
	private cell!: Cell;
	
	private SIZE: number = Grid.SIZE;
	private HYPPO_SIZE: number = Math.sqrt(Grid.SIZE * Grid.SIZE + Grid.SIZE * Grid.SIZE);
	
	@Emit()
	public onBeforeConfirm(): void {
	}
	
	@Emit()
	public onConfirm(): void {
	}
	
	private onSelect(): void {
		console.log(this.cell.x, this.cell.y);
		if (!this.cell.isHoverable) {
			return;
		}
		if (this.cell.selected || !this.cell.grid.selected) {
			this.cell.selected = !this.cell.selected;
		}
	}
	
	private onConfirmTop(): void {
		this.onBeforeConfirm();
		this.cell.traceTop();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmBottom(): void {
		this.onBeforeConfirm();
		this.cell.traceBottom();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmLeft(): void {
		this.onBeforeConfirm();
		this.cell.traceLeft();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmRight(): void {
		this.onBeforeConfirm();
		this.cell.traceRight();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmTopRight(): void {
		this.onBeforeConfirm();
		this.cell.traceTopRight();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmTopLeft(): void {
		this.onBeforeConfirm();
		this.cell.traceTopLeft();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmBottomRight(): void {
		this.onBeforeConfirm();
		this.cell.traceBottomRight();
		this.cell.selected = false;
		this.onConfirm();
	}
	
	private onConfirmBottomLeft(): void {
		this.onBeforeConfirm();
		this.cell.traceBottomLeft();
		this.cell.selected = false;
		this.onConfirm();
	}
}

